import React from "react"
import { navigate } from "gatsby"
import formatTimeRange from "../utils/format-time-range"
import classNames from "../utils/classnames"
import Link from "./link"

interface IEventListItemProps {
  node: Queries.EventItemFieldsFragment
  horizontal?: boolean
}

function EventListItem({
  node,
  horizontal = false,
}: IEventListItemProps): JSX.Element {
  const startDate = new Date(node?.eventStartDate)
  const endDate = new Date(node?.eventEndDate)
  const isSameDay = startDate.getDate() === endDate.getDate()
  const isSameMonth = startDate.getMonth() === endDate.getMonth()
  const dateOfMonth = startDate.getDate()
  const endDateOfMonth = endDate.getDate()
  const month = startDate.toLocaleString(`default`, { month: `short` })
  const endMonth = endDate.toLocaleString(`default`, { month: `short` })
  const isAllDay =
    node?.startTime === `00:00:00` && node?.endTime === `23:59:59`
  const timeString = formatTimeRange(
    node?.startTime?.replace(`:`, ``).substring(0, 4),
    node?.endTime?.replace(`:`, ``).substring(0, 4)
  )
  const startTimeString = timeString.split(` to `)[0]
  const endTimeString = timeString.split(` to `)[1]
  return (
    <div
      onClick={() => navigate(node.uri)}
      className="relative flex items-center align-middle gap-4 hover:bg-lightgray hover:cursor-pointer"
      style={{
        backgroundColor: node?.eventCategories?.nodes.find(
          n => n.slug === `college-events`
        )
          ? `rgba(69, 85, 96, 0.1)`
          : `#e7f2fa`,
      }}
    >
      <span
        className="relative w-[24%] lg:w-[16%] aspect-square flex flex-col items-center align-middle justify-center p-2"
        style={{
          borderLeftWidth: 4,
          borderLeftColor: node?.eventCategories?.nodes.find(
            n => n.slug === `college-events`
          )
            ? `#455560`
            : `#004b87`,
        }}
      >
        <time
          className={classNames(
            `block font-bold text-center`,
            !isSameDay ? `text-xs lg:text-xl` : `text-3xl`
          )}
          dateTime={node.eventStartDate}
        >
          {dateOfMonth}
          {!isSameDay ? ` - ${endDateOfMonth}` : ``}
        </time>
        <time
          className={classNames(
            `text-gray uppercase text-center`,
            !isSameMonth ? `text-[10px] lg:text-xs` : `text-lg`
          )}
          dateTime={node.eventStartDate}
        >
          {month}
          {!isSameMonth ? ` - ${endMonth}` : ``}
        </time>
      </span>
      <span className="w-[56%] lg:w-[64%]">
        <Link
          to={node.uri}
          data-categories={node.eventCategories.nodes
            .map(n => n.slug)
            .join(`,`)}
        >
          {node.title}
        </Link>
      </span>
      <span className="w-[20%] flex flex-col items-center align-middle justify-center">
        {isAllDay ? (
          <span className="uppercase text-xl font-bold text-center">
            All
            <br />
            Day
          </span>
        ) : (
          <>
            <time
              className="text-xs lg:text-lg font-semibold text-center"
              dateTime={node.startTime}
            >
              {startTimeString}
            </time>
            <span className="text-gray text-sm">TO</span>
            <time
              className="text-xs lg:text-lg font-semibold text-center"
              dateTime={node.endTime}
            >
              {endTimeString}
            </time>
          </>
        )}
      </span>
    </div>
  )
}

export default EventListItem
